import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Footer from "@/components/Footer";

const COMPANY = {
  name: "AXD - EVERY TRANS S.R.L.",
  reg: "J2022001044526",
  cif: "RO46998538",
  address: "Str. Decebal, camera 1, bl. 59/2D, sc. B, et. 4, ap. 35, Mun. Giurgiu, jud. Giurgiu",
  email: "contact@deter-ecobox.ro",
  phone: "+40 (785) 454 967",
};

const NAV = [
  { slug: "termeni-si-conditii", label: "Termeni și Condiții" },
  { slug: "confidentialitate", label: "Confidențialitate (GDPR)" },
  { slug: "cookies", label: "Politica de Cookie-uri" },
  { slug: "retur", label: "Retur & Retragere" },
  { slug: "livrare", label: "Livrare & Plată" },
  { slug: "anpc", label: "ANPC / SAL" },
];

const LEGAL = {
  "termeni-si-conditii": {
    title: "Termeni și Condiții",
    sections: [
      { h: "1. Identificarea vânzătorului", body: [
        `Site-ul deter-ecobox.ro este administrat de ${COMPANY.name}, cu sediul în ${COMPANY.address}, înregistrată la Registrul Comerțului sub nr. ${COMPANY.reg}, cod de identificare fiscală ${COMPANY.cif}.`,
        `Date de contact: e-mail ${COMPANY.email}, telefon ${COMPANY.phone}.`,
      ]},
      { h: "2. Obiectul contractului", body: [
        "Prezentele condiții reglementează vânzarea de produse de curățenie (detergenți lichizi concentrați, balsamuri, degresanți și produse conexe) prin intermediul magazinului online către consumatori persoane fizice.",
        "Plasarea unei comenzi implică acceptarea integrală și necondiționată a acestor Termeni și Condiții.",
      ]},
      { h: "3. Produse și prețuri", body: [
        "Toate prețurile afișate sunt exprimate în lei (RON) și includ TVA. Prețul aplicabil este cel afișat în momentul plasării comenzii.",
        "Ne rezervăm dreptul de a modifica prețurile și disponibilitatea produselor fără notificare prealabilă; modificările nu afectează comenzile deja confirmate.",
      ]},
      { h: "4. Plasarea și confirmarea comenzii", body: [
        "Comanda se plasează prin adăugarea produselor în coș și completarea datelor de livrare. Comanda devine fermă în momentul confirmării de către vânzător.",
        "Vânzătorul poate refuza o comandă în situații justificate (date incorecte, indisponibilitate stoc, suspiciune de fraudă), cu informarea clientului.",
      ]},
      { h: "5. Modalități de plată", body: [
        "Plata se poate efectua prin ramburs (numerar/card la livrare, către curier) sau prin alte metode indicate la finalizarea comenzii.",
        "Pentru fiecare comandă se emite factură fiscală, transmisă electronic.",
      ]},
      { h: "6. Livrare", body: [
        "Livrarea se realizează prin curier (Cargus) pe teritoriul României. Transportul este gratuit la toate comenzile, indiferent de valoare.",
        "Termenul estimativ de livrare este de 1–3 zile lucrătoare de la confirmarea comenzii.",
      ]},
      { h: "7. Dreptul de retragere (14 zile)", body: [
        "Conform OUG nr. 34/2014, consumatorul are dreptul de a se retrage din contract în termen de 14 zile calendaristice, fără penalități și fără invocarea unui motiv. Detalii complete în pagina „Retur & Retragere”.",
      ]},
      { h: "8. Garanția de conformitate", body: [
        "Produsele beneficiază de garanția legală de conformitate în condițiile OUG nr. 140/2021. Orice neconformitate constatată poate fi semnalată la datele de contact de mai sus.",
      ]},
      { h: "9. Răspundere", body: [
        "Vânzătorul nu răspunde pentru utilizarea necorespunzătoare a produselor, contrar instrucțiunilor de pe etichetă. Clientul are obligația de a citi și respecta indicațiile de utilizare și siguranță.",
      ]},
      { h: "10. Soluționarea litigiilor", body: [
        "Eventualele litigii se soluționează pe cale amiabilă. În caz contrar, consumatorul se poate adresa ANPC prin platforma de Soluționare Alternativă a Litigiilor (SAL) — vezi pagina „ANPC / SAL” — sau instanțelor judecătorești competente din România. Legea aplicabilă este legea română.",
      ]},
      { h: "11. Proprietate intelectuală", body: [
        "Conținutul site-ului (texte, imagini, mărci, grafică) este protejat și nu poate fi reprodus fără acordul scris al vânzătorului.",
      ]},
      { h: "12. Modificarea termenilor", body: [
        "Vânzătorul poate actualiza prezentele condiții. Versiunea aplicabilă unei comenzi este cea publicată la momentul plasării acesteia.",
      ]},
    ],
  },
  confidentialitate: {
    title: "Politica de Confidențialitate (GDPR)",
    sections: [
      { h: "1. Operatorul de date", body: [
        `${COMPANY.name}, ${COMPANY.address}, ${COMPANY.reg}, CIF ${COMPANY.cif}, este operatorul datelor cu caracter personal colectate prin site. Contact: ${COMPANY.email}, ${COMPANY.phone}.`,
      ]},
      { h: "2. Datele pe care le prelucrăm", body: [
        "Colectăm datele necesare procesării comenzilor:",
        ["Nume și prenume", "Adresă de livrare / facturare", "Număr de telefon", "Adresă de e-mail", "Detalii comandă și istoric", "Date tehnice (adresă IP, cookie-uri) pentru funcționarea și analiza site-ului"],
      ]},
      { h: "3. Scopurile prelucrării", body: [
        ["Procesarea, livrarea și facturarea comenzilor", "Comunicarea privind statusul comenzii", "Îndeplinirea obligațiilor legale (fiscale, contabile)", "Îmbunătățirea site-ului și marketing (doar cu consimțământ)"],
      ]},
      { h: "4. Temeiul legal", body: [
        "Prelucrarea se întemeiază pe executarea contractului (art. 6(1)(b) GDPR), obligații legale (art. 6(1)(c)) și, unde este cazul, consimțământul dumneavoastră (art. 6(1)(a)).",
      ]},
      { h: "5. Destinatarii datelor", body: [
        "Datele pot fi transmise partenerilor care ne sprijină în livrare și facturare, exclusiv în scopul îndeplinirii comenzii:",
        ["Firma de curierat (Cargus) — pentru livrare", "Furnizorul de facturare (Oblio) — pentru emiterea facturilor", "Autoritățile publice, când legea o impune"],
      ]},
      { h: "6. Durata stocării", body: [
        "Păstrăm datele pe durata necesară scopurilor de mai sus și în conformitate cu termenele legale de arhivare (ex. documentele financiar-contabile — 10 ani).",
      ]},
      { h: "7. Drepturile dumneavoastră", body: [
        "Conform GDPR, beneficiați de:",
        ["Dreptul de acces la date", "Dreptul la rectificare", "Dreptul la ștergere („dreptul de a fi uitat”)", "Dreptul la restricționarea prelucrării", "Dreptul la portabilitatea datelor", "Dreptul de opoziție", "Dreptul de a vă retrage consimțământul"],
        `Vă puteți exercita drepturile printr-o cerere la ${COMPANY.email}. De asemenea, vă puteți adresa Autorității Naționale de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP, www.dataprotection.ro).`,
      ]},
    ],
  },
  cookies: {
    title: "Politica de Cookie-uri",
    sections: [
      { h: "1. Ce sunt cookie-urile", body: [
        "Cookie-urile sunt fișiere text de mici dimensiuni stocate pe dispozitivul dumneavoastră, care ajută site-ul să funcționeze corect și să vă ofere o experiență mai bună.",
      ]},
      { h: "2. Tipuri de cookie-uri utilizate", body: [
        ["Cookie-uri strict necesare — pentru funcționarea coșului și a sesiunii; nu pot fi dezactivate.", "Cookie-uri de analiză și marketing — de exemplu Meta Pixel (Facebook), folosite pentru măsurarea traficului și optimizarea campaniilor, doar cu consimțământul dumneavoastră."],
      ]},
      { h: "3. Gestionarea cookie-urilor", body: [
        "Puteți controla și șterge cookie-urile din setările browserului. Dezactivarea anumitor cookie-uri poate afecta funcționalitatea site-ului.",
      ]},
      { h: "4. Consimțământ", body: [
        "Prin continuarea navigării și acceptarea bannerului de cookie-uri, vă exprimați acordul pentru utilizarea cookie-urilor opționale. Consimțământul poate fi retras oricând.",
      ]},
    ],
  },
  retur: {
    title: "Politica de Retur și Retragere",
    sections: [
      { h: "1. Dreptul legal de retragere", body: [
        "Conform OUG nr. 34/2014, în calitate de consumator aveți dreptul de a vă retrage din contractul de vânzare în termen de 14 zile calendaristice de la data la care intrați în posesia produselor, fără a fi nevoie să justificați decizia și fără penalități.",
      ]},
      { h: "2. Cum exercitați dreptul de retragere", body: [
        `Ne informați despre decizia dumneavoastră printr-o declarație neechivocă (e-mail la ${COMPANY.email} sau telefon ${COMPANY.phone}), menționând numărul comenzii.`,
        "Produsele trebuie returnate în starea în care le-ați primit, în ambalajul original, complete.",
      ]},
      { h: "3. Excepții de la dreptul de retragere", body: [
        "Nu pot fi returnate produsele sigilate care nu pot fi înapoiate din motive de protecție a sănătății sau din motive de igienă și care au fost desigilate după livrare, conform art. 16 din OUG 34/2014.",
      ]},
      { h: "4. Rambursarea", body: [
        "Vom rambursa contravaloarea produselor returnate în termen de maximum 14 zile de la data la care am fost informați, folosind aceeași modalitate de plată (sau prin transfer bancar, la cererea dumneavoastră).",
        "Costul returnării produselor este suportat de client, cu excepția cazului în care produsul a fost livrat greșit sau este neconform.",
      ]},
    ],
  },
  livrare: {
    title: "Livrare și Plată",
    sections: [
      { h: "1. Zona și modalitatea de livrare", body: [
        "Livrăm pe întreg teritoriul României prin curier rapid (Cargus). La expediere veți primi numărul AWB pentru urmărirea coletului.",
      ]},
      { h: "2. Costuri de livrare", body: [
        "Transport GRATUIT la toate comenzile, indiferent de valoare.",
      ]},
      { h: "3. Termen de livrare", body: [
        "Comenzile sunt procesate în 1–2 zile lucrătoare, iar livrarea se realizează în general în 1–3 zile lucrătoare de la confirmare.",
      ]},
      { h: "4. Modalități de plată", body: [
        "Plata se efectuează prin ramburs (numerar sau card la curier). Pentru fiecare comandă emitem factură fiscală.",
      ]},
    ],
  },
  anpc: {
    title: "ANPC — Soluționarea Alternativă a Litigiilor (SAL)",
    sections: [
      { h: "Soluționarea Alternativă a Litigiilor", body: [
        "În conformitate cu legislația în vigoare, consumatorii se pot adresa Autorității Naționale pentru Protecția Consumatorilor (ANPC) pentru soluționarea alternativă a litigiilor (SAL).",
        "Platforma electronică SAL este disponibilă la adresa: https://reclamatiisal.anpc.ro",
      ]},
      { h: "Date de contact ANPC", body: [
        ["Website: www.anpc.ro", "Platformă SAL: https://reclamatiisal.anpc.ro"],
      ]},
      { h: "Notă privind platforma SOL/ODR", body: [
        "Platforma europeană de Soluționare Online a Litigiilor (SOL/ODR) a fost închisă la 20 iulie 2025. Pentru litigii transfrontaliere vă puteți adresa Rețelei Centrelor Europene ale Consumatorilor (ECC-Net).",
      ]},
    ],
  },
};

function renderBody(body) {
  return body.map((b, i) =>
    Array.isArray(b) ? (
      <ul key={i} className="list-disc pl-6 space-y-2 my-4 text-[#4A4844]">
        {b.map((li, j) => <li key={j}>{li}</li>)}
      </ul>
    ) : (
      <p key={i} className="text-[#4A4844] leading-relaxed my-3">{b}</p>
    )
  );
}

export default function Legal() {
  const { slug } = useParams();
  const doc = LEGAL[slug] || LEGAL["termeni-si-conditii"];

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  return (
    <>
      <main className="min-h-screen pt-32 pb-24" data-testid={`legal-page-${slug}`}>
        <div className="mx-auto max-w-[1000px] px-6 md:px-12">
          <Link to="/" className="text-xs tracking-[0.3em] uppercase text-gramur hover:text-[#0E0F12] transition-colors" data-testid="legal-back-home">
            ← Înapoi la magazin
          </Link>

          <h1 className="font-serif font-light text-4xl md:text-6xl leading-[1.05] tracking-tight mt-6 mb-4">
            {doc.title}
          </h1>
          <p className="text-xs text-[#4A4844] mb-10">Ultima actualizare: iulie 2026</p>

          <div className="flex flex-wrap gap-2 mb-12 pb-8 border-b border-black/10">
            {NAV.map((n) => (
              <Link
                key={n.slug}
                to={`/legal/${n.slug}`}
                data-testid={`legal-nav-${n.slug}`}
                className={`text-xs px-3 py-2 rounded-sm border transition-colors ${
                  n.slug === slug
                    ? "bg-[#0E0F12] text-[#EDEAE3] border-[#0E0F12]"
                    : "border-black/15 text-[#4A4844] hover:border-gramur hover:text-[#0E0F12]"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </div>

          <article className="max-w-none">
            {doc.sections.map((s, i) => (
              <section key={i} className="mb-8">
                <h2 className="font-sans font-semibold text-lg md:text-xl text-[#0E0F12] mb-2">{s.h}</h2>
                {renderBody(s.body)}
              </section>
            ))}
          </article>
        </div>
      </main>
      <Footer />
    </>
  );
}
